import { useState, useEffect } from 'react';

const cached = [];
export default (src, async = false) => {
  // Keeping track of script loaded and error state
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (src) {
      if (cached.some(item => item === src)) {
        setLoaded(true);
      } else {
        cached.push(src);
        // Create script
        const script = document.createElement('script');
        script.src = src;
        script.async = async;

        // Script event listener callbacks for load and error
        const onLoad = () => {
          setLoaded(true);
          setError(false);
        };

        const onError = () => {
          const index = cached.indexOf(src);
          if (index >= 0) cached.splice(index, 1);
          script.remove();
          setLoaded(false);
          setError(true);
        };

        script.addEventListener('load', onLoad);
        script.addEventListener('error', onError);

        // Add script to document body
        document.body.appendChild(script);

        return () => {
          script.removeEventListener('load', onLoad);
          script.removeEventListener('error', onError);
        };
      }
    }
    return () => {};
  }, [src]);

  return [loaded, error];
};
